<template>
<div>
    <el-tag>C/C++</el-tag>
    <el-tag type="success">Java</el-tag>
    <el-tag type="warning">Python</el-tag>
    <el-tag type="danger">Unity3D</el-tag>
    <el-tag type="success">C#</el-tag>
    <el-tag type="info">LaTeX</el-tag>
    <el-tag>PostgreSQL</el-tag>
    <el-tag type="success">Web</el-tag>
    <el-tag type="danger">Pytorch</el-tag>
</div>
</template>

<script>
// import jwt from 'jsonwebtoken'
export default {
  name: 'Skills'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Skills.vue